<template>
  <div>
    <!-- 公共头 -->
    <hhead></hhead>
    <!-- 公共固定导航条 -->
    <nnav></nnav>
    <div class="bgimg" :style="{ display: 'grid' }">
      <div class="userlist">
        <div class="list_head">
          <!-- 搜索 -->
          <div class="topTitle" style="margin-left: 40px;padding: 8px 0  ;">
            <img
              style="margin-right: 8px;"
              src="../../../assets/images/dh111.png"
              alt=""
            />
            <span style="font-size: 14px;color: #2C2F37;">云服务</span
            ><span style="color: #868E99;font-size: 14px;"
              >&nbsp;>&nbsp;多账户拟合分析</span
            >
          </div>
          <!-- 账户列表 -->
          <div v-if="!contrast" class="contnet" :style="{ minHeight: MHeight }">
            <div class="search">
              <el-button icon="el-icon-plus" type="primary" @click="added"
                >添加</el-button
              >
            </div>
            <!-- 表格 -->
            <div class="table">
              <el-table
                :data="tableData"
                border
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  prop="operation"
                  label="操作"
                  width="62"
                  hieght="38"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      @click="
                        edit_btn(scope.row.id, scope.row.serverManageName)
                      "
                      :style="{ color: '#5B85FF', cursor: 'pointer' }"
                      class="iconfont icon-bianji decoration"
                    ></i>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="contrast"
                  label="对比分析"
                  width="100"
                >
                  <template slot-scope="scope">
                    <i
                      @click="contrast_block(scope.row.id)"
                      :style="{ color: '#5B85FF', cursor: 'pointer' }"
                      class="iconfont icon-analysis decoration"
                    ></i>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="serverManageName"
                  label="私有云名称"
                  width="140"
                >
                </el-table-column>
                <el-table-column prop="evalListName" label="对比账户">
                </el-table-column>
                <el-table-column prop="" label="创建时间" width="140">
                  <template slot-scope="scope">
                    <span>{{ scope.row.addTime | renderTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="修改时间" width="140">
                  <template slot-scope="scope">
                    <span>{{ scope.row.modTime | renderTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="delete"
                  align="center"
                  label="删除"
                  width="62"
                >
                  <template slot-scope="scope">
                    <i
                      @click="
                        deleteItem(
                          scope.row.id,
                          scope.row.serverManageName,
                          scope.$index
                        )
                      "
                      :style="{ color: '#5B85FF', cursor: 'pointer' }"
                      class="iconfont icon-shanchu decoration
                      "
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页 -->
            <div class="page_box">
              <div class="msg_count">共&nbsp;{{ length }}&nbsp;条</div>
              <div class="blank"></div>
              <div class="page">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="pageLength"
                  @next-click="addPage"
                  @prev-click="reducePage"
                  @current-change="currentPage"
                >
                </el-pagination>
              </div>
            </div>
          </div>

          <!-- 对比分析 -->
          <div v-if="contrast" class="contrast_show">
            <!-- 头部按钮 -->
            <div class="btn_top">
              <div @click="contrast = false" class="btn_l">
                返回
              </div>
              <div class="btn_r">
                导出
              </div>
            </div>
            <!-- 标题 -->
            <h3>云端体验-多账户拟合分析</h3>
            <!-- 净值 -->
            <div class="main">
              <div id="main1" style="height: 100%;"></div>
            </div>

            <!-- 回撤 -->
            <div class="main">
              <div id="main2" style="height: 100%;"></div>
            </div>
            <!-- 表格 -->
            <el-table
              :data="table_"
              border
              style="width: 100%;margin-bottom: 20px;"
            >
              <el-table-column prop="userName" label="姓名" width="">
              </el-table-column>
              <el-table-column prop="userCode" label="账户" width="">
              </el-table-column>

              <el-table-column prop="" label="净值" width="">
                <template slot-scope="scope">
                  <span>{{ (scope.row.profitRate + 1) | round2 }}</span>
                </template>
              </el-table-column>

              <el-table-column
                prop="yearlyProfitRate"
                label="年化收益率"
                width=""
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.yearlyProfitRate | round }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="maxLoss" label="峰值回撤" width="">
                <template slot-scope="scope">
                  <span>{{ scope.row.maxLoss | round }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="sharpeRate" label="夏普比率" width="">
                <template slot-scope="scope">
                  <span>{{ scope.row.sharpeRate | round1 }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="sortinoRate" label="索提诺比例" width="">
                <template slot-scope="scope">
                  <span>{{ scope.row.sortinoRate | round1 }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="profitRiskCp" label="收益风险比" width="">
                <template slot-scope="scope">
                  <span>{{ scope.row.profitRiskCp | round1 }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="yearlyWave" label="年化波动" width="">
                <template slot-scope="scope">
                  <span>{{ scope.row.yearlyWave | round }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <!-- 遮罩层 -->
      <div class="popContainer" v-show="show">
        <div class="add" style="width: 800px;">
          <span
            class="close iconfont icon-close_round_fill_bold
            "
            @click="cancel"
          ></span>
          <div class="Top">
            {{ addEdit }}
          </div>
          <div class="add_body">
            <p style="color: #181E2D;font-size: 16px;">
              <i style="color: red;">*&nbsp;</i>私有云名称
            </p>
            <!-- 点击编辑显示 -->
            <div class="inp_disabled" v-if="add_edit">
              <el-input :placeholder="edit_name" :disabled="true"> </el-input>
            </div>
            <!-- 点击添加显示 -->
            <label
              class="yunName"
              style="width: 630px;margin-bottom: 20px;"
              v-if="!add_edit"
            >
              <span
                @mousedown="yun"
                :style="{ color: y_Name ? '#5B85FF' : '#868E99' }"
                >{{ y_Name ? y_Name : '私有云名称' }}</span
              ><i @click="yun" class="el-icon-arrow-down"></i>
              <!-- <transition name="el-fade-in-linear"> -->
              <div class="yunName_select" v-show="yunName_show">
                <input type="text" @blur="yunName_show = false" />
                <p
                  v-for="(item, index) in yunNameList"
                  :key="index"
                  @mousedown="accountTypeAdd(item.name, item.value)"
                >
                  {{ item.name }}
                </p>
                <li v-show="yunNameList.length ? false : true">未找到结果</li>
              </div>
              <!-- </transition> -->
            </label>
            <p
              v-show="y_error"
              :style="{ color: '#f39c12', padding: '10px 0' }"
            >
              <i class="el-icon-warning-outline"></i>
              访问私有云失败，无法查询管理员下的账户列表
            </p>
            <p style="color: #181E2D;font-size: 16px;">
              <i style="color: red;">*&nbsp;</i>对比账户
            </p>

            <el-checkbox-group v-model="checkList" v-loading="loading">
              <el-checkbox
                :label="item.name"
                v-for="(item, index) in checkItem"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <p
              v-show="user_none"
              :style="{ color: '#f39c12', padding: '10px 0' }"
            >
              <i class="el-icon-warning-outline"></i> 暂无账户可对比
            </p>
          </div>
          <div class="form_btn">
            <!-- <button type="info" round @click="cancel">取消</button> -->
            <button type="primary" @click="submit">提交</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import hhead from '../../../components/header/index';
import nnav from '../../../components/nav/index';
import './style.css';
import '@/assets/icon/iconfont.css';
const echarts = require('echarts');
export default {
  name: 'account_contrast',
  components: { hhead, nnav },
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 160 + 'px',
      loading: true,
      url_add: false,
      add_edit: false,
      show: false,
      yunName_show: false,
      page: 0, //当前分页
      length: '', //账户列表总数
      pageLength: null, //账户列表分页长度,
      yunNameList: [],
      y_Name: '',
      addEdit: '',
      y_Name_f: '',
      valueList: '',
      yun_value: '',
      edit_name: '',
      edit_id: '',
      user_none: false,
      y_error: false,
      tableData: [],
      accountTypeList: ['投顾账户', '产品独立账户'],
      checkList: [], //选中的对比账户
      checkItem: [], //对比账户
      contrast: false,
      table_: [],
      option: {},
      colorArray: [
        '#ec0000',
        '#732acb',
        '#00d4de',
        '#FF7F00',
        '#3f769e',
        '#cda1ac',
        '#4f00a3',
        '#f5b868',
        '#5a8fea',
        '#FFD700',
        '#a06375',
        '#ca0073',
        '#a75602',
        '#000000',
        '#dea195',
        '#732acb',
        '#0000ba',
        '#a7cdc9',
        '#df829a',
        '#8E388E',
        '#ff00ff',
      ],
    };
  },
  filters: {
    //时间戳转换
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      let h = date.getHours();
      h = h < 10 ? '0' + h : h;
      let m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      let s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //2020-12-11T05:27:56.370+0000转换
    renderTime: function(date) {
      if (date) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, ' ')
          .replace(/\.[\d]{3}Z/, '')
          .substr(0, 16);
      }
    },
    round: function(num) {
      return (Math.round(num * 10000) / 100).toFixed(2) + '%';
    },
    round1: function(num) {
      return (Math.round(num * 100) / 100).toFixed(2);
    },
    round2: function(num) {
      return (Math.round(num * 10000) / 10000).toFixed(4);
    },
  },
  created() {
    this.pageAxios();
    this.$axios({
      method: 'post',
      url: '/cloud/account_contrast/list',
      params: {
        page_no: 1,
        size: 10000,

        apiToken: this.$store.state.usermsg.apiToken,
      },
    }).then((res) => {
      // console.log(res);
      this.tokenInvalid(res);
      if (res.data.code == 200) {
        this.length = res.data.data.length;
        this.pageLength = Math.ceil(res.data.data.length);
        // console.log(this.pageLength);
      }
      // // console.log(this.tableData)
    });
  },
  mounted() {},
  methods: {
    // 净值echarts
    worth() {
      // // console.log(this.option.jsonObject.netValueUserNames);
      var chartDom = document.getElementById('main1');
      var myChart = echarts.init(chartDom);
      let JzList = [];

      for (let i = 0; i < this.option.jsonObject.data.length; i++) {
        let obj = {};
        obj.symbol = 'none';
        obj.name = this.option.jsonObject.netValueUserNames[i];
        obj.type = 'line';
        obj.data = this.option.jsonObject.data[i];

        JzList.push(obj);
      }
      var option = {
        title: {
          text: '净值',
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: this.option.jsonObject.netValueUserNames,
          right: 30,
          top: 6,
          // x: 'right',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.option.jsonObject.times,
        },
        yAxis: {
          type: 'value',
          scale: true,
          boundaryGap: ['10%', '10%'],
        },

        series: JzList,
        color: this.colorArray,
      };
      option && myChart.setOption(option);
    },
    // 回撤图
    retracement() {
      var chartDom = document.getElementById('main2');
      var myChart = echarts.init(chartDom);
      let JzList = [];

      for (let i = 0; i < this.option.jsonObject.hcData.length; i++) {
        let obj = {};
        obj.symbol = 'none';
        obj.name = this.option.jsonObject.hcValueUserNames[i];
        obj.type = 'line';
        obj.data = this.option.jsonObject.hcData[i];

        JzList.push(obj);
      }
      var option = {
        title: {
          text: '回撤',
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: this.option.jsonObject.hcValueUserNames,
          right: 30,
          top: 6,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.option.jsonObject.times,
        },
        yAxis: {
          // type: 'value',
          // min: 'dataMin',
          // max: 'dataMax',
          type: 'value',
          scale: true,
          boundaryGap: ['10%', '10%'],
        },
        series: JzList,
        color: this.colorArray,
      };

      option && myChart.setOption(option);
    },
    contrast_block(id) {
      //查看对比分析

      this.contrast = true;
      this.$axios
        .post('/cloud/account_contrast/viewRepo', {
          id: id,
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          // console.log(res.data.data);
          this.tokenInvalid(res);
          this.option = res.data.data;
          this.table_ = res.data.data.list;
          this.worth(); //净值
          this.retracement(); //回撤
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    pageAxios() {
      this.$axios({
        method: 'post',
        url: '/cloud/account_contrast/list',
        params: {
          page_no: this.page,
          size: 10,
          apiToken: this.$store.state.usermsg.apiToken,
        },
      }).then((res) => {
        // console.log(res);
        this.tokenInvalid(res);
        if (res.data.code == 200) {
          this.tableData = res.data.data;
        }
        // // console.log(this.tableData)
      });
    },
    added() {
      //添加按钮
      this.addEdit = '添加';
      this.url_add = true;
      this.show = true;
      this.add_edit = false;
      this.$axios({
        //获取私有云名称列表
        method: 'post',
        url: '/cloud/account_contrast/add_ajax',
        params: {
          apiToken: this.$store.state.usermsg.apiToken,
        },
      })
        .then((res) => {
          // // console.log(res)
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            res.data.data.splice('0', 1);
            this.yunNameList = res.data.data;
            // console.log(this.yunNameList);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    yun(e) {
      //私有云名称按钮

      this.yunName_show = !this.yunName_show;
    },
    yun_b() {
      this.yunName_b = !this.yunName_b;
    },
    accountAdd() {
      //账户类型按钮
      this.accountTypeShow = !this.accountTypeShow;
    },
    error() {
      //账户X按钮
      this.account = '';
      this.err_show = false;
    },
    error1() {
      //姓名X按钮
      this.name = '';
      this.err_show1 = false;
    },
    focus_account() {
      //账户输入框聚焦
      this.err_show = false;
    },
    focus_name() {
      //姓名输入框聚焦
      this.err_show1 = false;
    },
    blur_account() {
      //账户输入框失焦
      this.err_show = true;
    },
    blur_name() {
      //姓名输入框失焦
      this.err_show1 = true;
    },
    reset() {
      //重置按钮
      this.account = '';
      this.name = '';
      this.accountType = '账户类型';
      this.yun_name = '私有云名称';
    },
    accountTypeAdd(name, value) {
      //查询当前私有云下的可对比账户
      this.yun_value = value;
      // console.log(this.yun_value);
      this.y_Name = name;
      this.$axios({
        method: 'post',
        url: '/cloud/account_contrast/get_eval',
        // transformRequest: [
        //   function(data) {
        //     let ret = '';
        //     for (let it in data) {
        //       ret +=
        //         encodeURIComponent(it) +
        //         '=' +
        //         encodeURIComponent(data[it]) +
        //         '&';
        //     }
        //     return ret;
        //   },
        // ],
        data: {
          serverManageId: value,
          apiToken: this.$store.state.usermsg.apiToken,
        },
      })
        .then((res) => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.checkItem = res.data.data;
            this.y_error = false;
          }
          if (!this.checkItem.length) {
            this.user_none = true;
          } else {
            this.user_none = false;
          }
        })
        .catch((err) => {
          // console.log(err);
          this.checkItem = [];
          this.user_none = true;
          this.y_error = true;
        });
    },

    cancel() {
      this.show = false;

      this.checkItem = [];
      this.yunNameList = [];
      this.y_Name = '';
      this.valueList = '';
      this.checkList = [];
    },
    inp_blurUser() {
      this.accountTypeShow = false;
    },
    inp_blur() {
      this.yunName = false;
    },
    inp_blur_b() {
      this.yunName_b = false;
    },
    submit() {
      //提交
      //选中的value
      this.valueList = '';
      this.checkList.forEach((item) => {
        this.checkItem.forEach((i) => {
          if (item.indexOf(i.name) != -1) {
            this.valueList += ',' + i.value;
          }
        });
      });
      // console.log(this.valueList, this.checkList);
      if (this.checkList.length >= 2) {
        x;
        //提交请求
        let checkList = '';
        this.checkList.forEach((item) => {
          checkList += ',' + item;
        });

        this.$axios
          .post(
            this.url_add
              ? '/cloud/account_contrast/saveNew'
              : '/cloud/account_contrast/saveEdit',
            {
              evalJees: this.valueList.replace(',', ''),
              jeesCodeName: checkList.replace(',', ''),
              apiToken: this.$store.state.usermsg.apiToken,
              serverManageId: this.yun_value,
              id: this.edit_id,
            }
          )
          .then((res) => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: res.data.message,
              });
              this.pageAxios();
              this.show = false;
              this.checkItem = [];
              this.yunNameList = [];
              this.y_Name = '';
              this.valueList = '';
              this.checkList = [];
            }
          })
          .catch((err) => {
            // console.log(err);
          });
        //         this.$axios.post(this.$store.state.api + '/cloud/account_contrast/saveNew', {
        //       data: {
        //         evalJees: this.valueList.replace(',',''),
        //               jeesCodeName: checkList.replace(',',''),
        //               apiToken:this.$store.state.usermsg.apiToken,
        //               serverManageId:this.yun_value
        //       }
        //             },{

        //     withCredentials : true
        // }).then(res=>{
        //   // console.log(res)
        // }).catch(err=>{
        //   // console.log(err)
        // })
      } else {
        this.$message({
          showClose: true,
          message: '请选择两项数据对比',
          type: 'error',
        });
      }
    },
    user_blur() {
      if (this.user.length == 0) {
        this.user_show = true;
      } else {
        this.user_show = false;
      }
    },
    pwd_blur() {
      if (this.pwd.length == 0) {
        this.pwd_show = true;
      } else {
        this.pwd_show = false;
      }
    },
    addPage(e) {
      //分页 下一页
      //  this.page = e
      //  // console.log(this.page)
    },
    reducePage(e) {
      //上一页
      // this.page = e
      // // console.log(this.page)
    },
    currentPage(e) {
      //当前页
      this.page = e;
      this.pageAxios();
    },
    deleteItem(id, Code, row) {
      //删除
      let that = this;
      //  // console.log(row)
      this.$confirm(`确认删除“${Code}”的这条账户拟合分析吗？？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$axios({
            method: 'post',
            url: '/cloud/account_contrast/del',
            params: {
              id: id,
              apiToken: this.$store.state.usermsg.apiToken,
            },
          })
            .then((res) => {
              // console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                that.pageAxios();
                that.length--;
                if (that.tableData.length > 1) {
                  that.pageLength--;
                }

                this.$message({
                  type: 'success',
                  message: '删除成功!',
                });
              } else {
                this.$message({
                  type: 'info',
                  message: '删除失败',
                });
              }
              // // console.log(this.tableData)
            })
            .catch((err) => {
              // console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    edit_btn(id, name) {
      //操作编辑按钮
      this.url_add = false;
      // console.log(this.url_add);
      this.addEdit = '修改';
      this.show = true;
      this.add_edit = true;
      this.edit_name = name;
      this.edit_id = id;
      this.$axios
        .post('/cloud/account_contrast/edit_ajax', {
          id: id,
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.checkItem = res.data.data;
            this.checkItem.forEach((item) => {
              if (item.selected) {
                this.checkList.push(item.name);
              }
            });
          }
        })
        .catch((res) => {
          // console.log(err);
        });
    },
  },
  watch: {
    contrast() {
      if (this.contrast == true) {
        var that = this;
        // setTimeout(function() {
        //   that.worth();
        //   that.retracement();
        // }, 100);
      }
    },
    account() {
      //监听账户输入框
      if (this.account.length > 0) {
        this.err_show = true;
      }
    },
    name() {
      //监听账户
      if (this.name.length > 0) {
        this.err_show1 = true;
      }
    },
    name_c() {
      if (this.name_c == 1) {
        this.addYun = true;
      }
      if (this.name_c == 2) {
        this.addYun = false;
      }
    },
    checkItem() {
      let that = this;
      that.loading = true;
      setTimeout(function() {
        that.loading = false;
      }, 300);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/user/account_contrast/index.vue